import React from "react";
import { AboutTeamMember } from "@tennr/frontend/components/AboutTeamMember";
import { Heading } from "@tennr/frontend/components/Heading";
import "./AboutTeamSection.css";

interface TeamMember {
  name: string;
  title: string;
  imageUrl: string;
  imageClassName?: string;
}

const leadershipTeam: TeamMember[] = [
  {
    name: "Trey Holterman",
    title: "CEO, Co-founder",
    imageUrl: "/img/team-members/trey-holterman.png",
  },
  {
    name: "Diego Baugh",
    title: "CPO, Co-founder",
    imageUrl: "/figma/img/team-diego-baugh.png",
  },
  {
    name: "Tyler Johnson",
    title: "CTO, Co-founder",
    imageUrl: "/figma/img/team-tyler-johnson.png",
  },
  {
    name: "AJ Kiefer",
    title: "Chief Customer Officer",
    imageUrl: "/figma/img/team-aj-kiefer.png",
  },
  {
    name: "Mark Hoffman",
    title: "Chief Sales Officer",
    imageUrl: "/figma/img/team-mark-hoffman.png",
  },
  {
    name: "Kenny Herman",
    title: "Chief Business Development Officer",
      imageUrl: "/img/team-members/kenny-herman.png",
  },
  {
    name: "Abe Griffiths",
    title: "VP of Operations",
    imageUrl: "https://c.animaapp.com/JRF9lhPw/img/rectangle-24593-19@2x.png",
  },
  {
    name: "Maddie Buras",
    title: "VP of Marketing",
    imageUrl: "/img/maddie-buras.jpg",
  },
  {
    name: "Lindsay Stein",
    title: "VP of Customer Success",
    imageUrl: "/img/team-members/lindsay-stein.jpg",
  },
];

const teamMembers: TeamMember[] = [
  {
    name: "Daniel Guillen",
    title: "Senior Software Engineer",
    imageUrl: "/img/team-members/daniel-guillen.jpg",
  },
  {
    name: "Matthew Forman",
    title: "VP of Business Development",
    imageUrl: "/img/team-members/matthew-forman.jpg",
  },
  {
    name: "Jasper den Otter",
    title: "Founding Tech Lead Manager",
    imageUrl: "/img/team-members/jasper-den-otter.jpg",
  },
  {
    name: "Madison Paulik",
    title: "Solutions Engineer",
    imageUrl: "/img/team-members/madison-paulik.jpg",
  },
  {
    name: "Henry Josephson",
    title: "Account Executive",
    imageUrl: "/img/team-members/henry-josephson.jpg",
  },
  {
    name: "Matt Dillabough",
    title: "Head of Solutions Architecting",
    imageUrl: "/img/team-members/matt-dillabough.jpg",
  },
  {
    name: "Jackson Wood",
    title: "Product Manager",
    imageUrl: "/img/team-members/jackson-wood.jpg",
  },
  {
    name: "Harry Burke",
    title: "Solutions Engineer",
    imageUrl: "/img/team-members/harry-burke.jpg",
  },
  {
    name: "Olivia Webb",
    title: "People Operations Associate",
    imageUrl: "/img/team-members/olivia-webb.jpg",
  },
  {
    name: "John Santillo",
    title: "Account Executive",
    imageUrl: "/img/team-members/john-santillo.jpg",
  },
  {
    name: "Lauren Laux",
    title: "Account Executive",
    imageUrl: "/img/team-members/lauren-laux.jpg",
  },
  {
    name: "Jack Steinberg",
    title: "Founding Tech Lead Manager",
    imageUrl: "/img/team-members/jack-steinberg.jpg",
  },
  {
    name: "Amanda Bozorgi",
    title: "Customer Success Manager",
    imageUrl: "/img/team-members/amanda-bozorgi.jpg",
  },
  {
    name: "Anant Khattar",
    title: "Solutions Architect Team Lead",
    imageUrl: "/img/team-members/anant-khattar.jpg",
  },
  {
    name: "Gabe Klee",
    title: "Senior Full-Stack Software Engineer",
    imageUrl: "/img/team-members/gabe-klee.jpg",
  },
  {
    name: "Mia Vandermeer",
    title: "Brand and Content Marketing Manager",
    imageUrl: "/img/team-members/mia-vandermeer.jpg",
  },
  {
    name: "Natalie Shclover",
    title: "Engagement Manager",
    imageUrl: "/img/team-members/natalie-shclover.jpg",
  },
  {
    name: "Spencer Paul",
    title: "Machine Learning Engineer",
    imageUrl: "/img/team-members/spencer-paul.jpg",
  },
  {
    name: "Alex Cook",
    title: "Enterprise Account Executive",
    imageUrl: "/img/team-members/alex-cook.jpg",
  },
  {
    name: "Kush Changela",
    title: "Full-stack Engineer",
    imageUrl: "/img/team-members/kush-changela.jpg",
  },
  {
    name: "Ashton Kozlik",
    title: "Account Executive",
    imageUrl: "/img/team-members/ashton-kozlik.jpg",
  },
  {
    name: "Jonina Hetfield",
    title: "Account Executive",
    imageUrl: "/img/team-members/joni-hetfield.jpg",
  },
  {
    name: "Khalid Elawad",
    title: "Product Marketing Manager",
    imageUrl: "/img/team-members/khalid-elawad.jpg",
  },
  {
    name: "Ben Howe",
    title: "Solutions Architect",
    imageUrl: "/img/team-members/ben-howe.jpg",
  },
  {
    name: "Johnathan Bridges",
    title: "Event Marketing Manager",
    imageUrl: "/img/team-members/johnathan-bridges.jpg",
  },
  {
    name: "Brian Sullivan",
    title: "Enterprise Solutions Architect",
    imageUrl: "/img/team-members/brian-sullivan.jpg",
  },
  {
    name: "Caroline Park",
    title: "Engagement Manager",
    imageUrl: "/img/team-members/caroline-park.jpg",
  },
  {
    name: "Elliott Chang",
    title: "Enterprise Customer Success Manager",
    imageUrl: "/img/team-members/elliott-chang.jpg",
  },
  {
    name: "Eleanor Reinhardt",
    title: "Sales Development Representative",
    imageUrl: "/img/team-members/eleanor-reinhardt.jpg",
  },
  {
    name: "Hannah Lawry",
    title: "Associate Solutions Architect",
    imageUrl: "/img/team-members/hannah-lawry.png",
  },
  {
    name: "Theodore Bronk",
    title: "Engagement Manager",
    imageUrl: "/img/team-members/teshie-bronk.jpg",
  },
  {
    name: "Samuel Berg",
    title: "VP of Sales",
    imageUrl: "/img/team-members/sam-berg.jpeg",
  },
  {
    name: "Greg Pelton",
    title: "Director of Revenue Enablement",
    imageUrl: "/img/team-members/greg-pelton.png",
  },
  {
    name: "Alexander Strunkin",
    title: "Founding Principal Product Manager",
    imageUrl: "/img/team-members/alexander-strunkin.png",
  },
  {
    name: "Andrew Crimer",
    title: "Director of Growth Marketing",
    imageUrl: "/img/team-members/andrew-crimer.png",
  },
  {
    name: "Ben Solo",
    title: "Jr Backend Engineer",
    imageUrl: "/img/team-members/ben-solo.jpeg",
  },
  {
    name: "Bruna Dos Santos",
    title: "Industry Specialist",
    imageUrl: "/img/team-members/bruna-dos-santos.jpeg",
  },
  {
    name: "Charlie Murphy",
    title: "Sr. Manager, Talent Acquisition",
    imageUrl: "/img/team-members/charlie-murphy.jpeg",
  },
  {
    name: "Chris Holt",
    title: "Engineering Manager",
    imageUrl: "/img/team-members/chris-holt.png",
  },
  {
    name: "David Gelland",
    title: "Sales Development Representative",
    imageUrl: "/img/team-members/david-gelland.jpeg",
  },
  {
    name: "Elizabeth Lubeck",
    title: "Full-Stack Software Engineer",
    imageUrl: "/img/team-members/elizabeth-lubeck.jpeg",
  },
  {
    name: "Enrique Saldivar",
    title: "Sr. Manager Finance",
    imageUrl: "/img/team-members/enrique-saldivar.jpeg",
  },
  {
    name: "Gabriel Brown",
    title: "Sales Development Representative",
    imageUrl: "/img/team-members/gabe-brown.jpeg",
  },
  {
    name: "Grace Ann Sweeney",
    title: "Director of Sales Development",
    imageUrl: "/img/team-members/grace-ann-sweeney.jpeg",
  },
  {
    name: "Isaac Finberg",
    title: "Senior Machine Learning Engineer",
    imageUrl: "/img/team-members/isaac-finberg.jpeg",
  },
  {
    name: "James Eigenbrood",
    title: "Enterprise Solutions Architect",
    imageUrl: "/img/team-members/james-eigenbrood.png",
  },
  {
    name: "Joanna Patalano",
    title: "Principal Executive Assistant & Office Manager",
    imageUrl: "/img/team-members/joanna-patalano.jpeg",
  },
  {
    name: "Joe Okai",
    title: "Enterprise Customer Success Manager",
    imageUrl: "/img/team-members/joseph-okai.jpeg",
  },
  {
    name: "Joe Rooney",
    title: "Strategic Account Executive",
    imageUrl: "/img/team-members/joe-rooney.jpeg",
  },
  {
    name: "John Laude",
    title: "Director of Solutions Engineering",
    imageUrl: "/img/team-members/john-laude.jpeg",
  },
  {
    name: "Joschka Braun",
    title: "Machine Learning Engineer",
    imageUrl: "/img/team-members/joschka-braun.jpg",
  },
  {
    name: "Josh Goldstein",
    title: "Backend Software Engineer",
    imageUrl: "/img/team-members/josh-goldstein.jpeg",
  },
  {
    name: "Kaitlin Bradley",
    title: "Legal Counsel",
    imageUrl: "/img/team-members/kaitlin-bradley.jpeg",
  },
  {
    name: "Katie Pelton",
    title: "Backend Software Engineer",
    imageUrl: "/img/team-members/katie-pelton.jpeg",
  },
  {
    name: "Liam King",
    title: "Solutions Architect",
    imageUrl: "/img/team-members/liam-king.jpeg",
  },
  {
    name: "Louis DeScioli",
    title: "Staff Full-Stack Software Engineer",
    imageUrl: "/img/team-members/louis-descioli.jpg",
  },
  {
    name: "Matthew Garcia",
    title: "Revenue Operations and Strategy Manager",
    imageUrl: "/img/team-members/matt-garcia.jpeg",
  },
  {
    name: "Michael Maffezzoli",
    title: "Associate Solutions Architect",
    imageUrl: "/img/team-members/michael-maffezzoli.jpeg",
  },
  {
    name: "Naman Agarwal",
    title: "Design Engineer",
    imageUrl: "/img/team-members/shadowy-figure.jpeg",
  },
  {
    name: "Anastasia Begun",
    title: "Staff Product Designer",
    imageUrl: "/img/team-members/anastasia-begun.jpeg",
  },
  {
    name: "Omar Sandhu",
    title: "Strategic Account Executive",
    imageUrl: "/img/team-members/omar-sandhu.jpeg",
  },
  {
    name: "Rafael Jacobovitz",
    title: "Senior Backend Software Engineer",
    imageUrl: "/img/team-members/rafael-jacobovitz.jpeg",
  },
  {
    name: "Reid Baltuch",
    title: "Sales Development Representative",
    imageUrl: "/img/team-members/reid-baltuch.jpeg",
  },
  {
    name: "Robert Berliner",
    title: "Sales Development Representative",
    imageUrl: "/img/team-members/robert-berliner.jpeg",
  },
  {
    name: "Selah Hampton",
    title: "Customer Success Manager",
    imageUrl: "/img/team-members/selah-hampton.jpeg",
  },
  {
    name: "Shivani Patel",
    title: "Backend Software Engineer",
    imageUrl: "/img/team-members/shivani-patel.jpeg",
  },
  {
    name: "Sydney Gil",
    title: "Engagement Manager",
    imageUrl: "/img/team-members/sydney-gil.jpeg",
  },
  {
    name: "Tom Crumley",
    title: "Enterprise Account Executive",
    imageUrl: "/img/team-members/tom-crumley.jpeg",
  },
  {
    name: "Tyler Douglas",
    title: "Enterprise Solutions Architect",
    imageUrl: "/img/team-members/tyler-douglas.jpeg",
  },
  {
    name: "Yash Jain",
    title: "Director of Operations",
    imageUrl: "/img/team-members/yash-jain.jpeg",
  },
  {
    name: "Paul Canty",
    title: "Enterprise Account Executive",
    imageUrl: "/img/team-members/paul-canty.jpg",
  },
  {
    name: "Jimmy Lehmberg",
    title: "Sales Development Representative",
    imageUrl: "/img/team-members/jimmy-lehmberg.jpeg",
  },
  {
    name: "Alfonso Pistone",
    title: "Strategic Account Executive",
    imageUrl: "/img/team-members/alfonso-pistone.png",
  },
  {
    name: "Ted Gatsos",
    title: "Sales Development Representative",
    imageUrl: "/img/team-members/ted-gatsos.png",
  },
  {
    name: "Melisa Isado",
    title: "Sales Development Representative",
    imageUrl: "/img/team-members/melisa-isado.jpeg",
  },
  {
    name: "George Simotas",
    title: "Associate Embedded Solutions Engineer",
    imageUrl: "/img/team-members/george-simotas.jpeg",
  },
  {
    name: "Clay Ostroff",
    title: "Associate Embedded Solutions Engineer",
    imageUrl: "/img/team-members/clay-ostroff.jpeg",
  },
  {
    name: "Ian Kennedy",
    title: "Associate Embedded Solutions Engineer",
    imageUrl: "/img/team-members/ian-kennedy.jpeg",
  },
  {
    name: "Will Healy",
    title: "Junior Machine Learning Engineer",
    imageUrl: "/img/team-members/will-healy.png",
  },
  {
    name: "Daniel Levi-Minzi",
    title: "Backend Software Engineer",
    imageUrl: "/img/team-members/daniel-levi-minzi.jpeg",
  },
  {
    name: "Jeff Parson",
    title: "Staff Backend Engineer",
    imageUrl: "/img/team-members/jeff-parsons.jpeg",
  },
  {
    name: "Jasper Wu",
    title: "Senior Product Manager",
    imageUrl: "/img/team-members/jasper-wu.jpg",
  },
];

export interface AboutTeamSectionProps {
  className?: string;
}

export const AboutTeamSection: React.FC<AboutTeamSectionProps> = () => {
  return (
    <section className="about-team-section">
      <div className="about-team-section__intro">
        <img
          className="about-team-section__photo"
          alt="Tennr team"
          src="/img/team-members/founding-team.png"
          loading="lazy"
          draggable={false}
        />
        <Heading
          title="THE TEAM"
          heading="Nice to meet you."
          body={"We\'re the team making healthcare move faster."}
          position="left"
          dark
          variant="section"
          width="100%"
          className="about-team-section__intro-content"
        />
      </div>

      <div className="about-team-section__leadership">
        <div className="about-team-section__leadership-grid">
          {leadershipTeam.slice(0).map((member) => (
            <AboutTeamMember
              key={member.name}
              variant="leadership"
              imageUrl={member.imageUrl}
              name={member.name}
              title={member.title}
              imageClassName={member.imageClassName}
            />
          ))}
        </div>
      </div>

      <div className="about-team-section__members">
        <div className="about-team-section__members-grid">
          {teamMembers.map((member) => (
            <AboutTeamMember
              key={member.name}
              variant="team"
              imageUrl={member.imageUrl}
              name={member.name}
              title={member.title}
              imageClassName={member.imageClassName}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
